import { QueryClient } from '@tanstack/react-query'

const WINDOW_FOCUS_TTL = 1000 * 60 * 5 // 5 minutes

// NOTE: default cacheTime is 5 minutes, which felt reasonable if not slightly long.
// We can update it here if we want to change it.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      // We want to refetch on window focus if the last fetch was more than WINDOW_FOCUS_TTL ago. We don't want to
      // necessarily rely on staleness since a query by default becomes stale immediately
      refetchOnWindowFocus: (query) => {
        const { dataUpdatedAt, errorUpdatedAt } = query.state
        // If the last update was an error, the dataUpdatedAt will be 0, so we use the errorUpdatedAt as a fallback.
        const lastUpdate = new Date(dataUpdatedAt || errorUpdatedAt).getTime()
        const now = new Date().getTime()
        const diff = now - lastUpdate
        return diff > WINDOW_FOCUS_TTL
      },
    },
  },
})
